import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-attachment-upload-success-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './attachment-upload-success-modal.component.html',
})
export class AttachmentUploadSuccessModalComponent {
  readonly activeModal = inject(NgbActiveModal);

  onClose(): void {
    this.activeModal.close();
  }
}

